import { render } from "./BtnRegist.vue?vue&type=template&id=268716fe&scoped=true"
import script from "./BtnRegist.vue?vue&type=script&lang=js"
export * from "./BtnRegist.vue?vue&type=script&lang=js"

import "./BtnRegist.vue?vue&type=style&index=0&id=268716fe&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/xz_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-268716fe"]])

export default __exports__